import { render, staticRenderFns } from "./adminFeeDetailList.vue?vue&type=template&id=b6f6c530&scoped=true"
import script from "./adminFeeDetailList.vue?vue&type=script&lang=js"
export * from "./adminFeeDetailList.vue?vue&type=script&lang=js"
import style0 from "./adminFeeDetailList.vue?vue&type=style&index=0&id=b6f6c530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f6c530",
  null
  
)

export default component.exports